<div class="gs-spinner">
  <div class="gs-spinner-ring"></div>
  <div class="gs-spinner-label">{{ 'Chargement' | translate }}…</div>
</div>
